export default __webpack_public_path__ + "static/media/Jobs_logo.6d6b0dc6.png";